import { render, staticRenderFns } from "./AdminUsersElement.vue?vue&type=template&id=6c244cd2&scoped=true"
import script from "./AdminUsersElement.vue?vue&type=script&lang=js"
export * from "./AdminUsersElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersElement.vue?vue&type=style&index=0&id=6c244cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c244cd2",
  null
  
)

export default component.exports